import { createStore } from "redux"
import allReducers from "./Reducers"
import { loadState, saveState } from "./localStorage"
import {message} from 'antd'


const initialData = loadState()

export const store = createStore(
    allReducers,
    initialData
);

store.subscribe(() => {
    if (storageAvailable('localStorage')){
        saveState(store.getState())
    } else{
        message.error('Tu navegador no es compatible con Liqui.app')
    }


})

function storageAvailable(type) {
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        // message.error("Error en storageAvailable")
        // console.log(e)
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
}